var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.03126 0C4.70503 0 2.8125 1.89253 2.8125 4.21876C2.8125 6.54498 4.70503 8.43752 7.03126 8.43752C9.35748 8.43752 11.25 6.54498 11.25 4.21876C11.25 1.89253 9.35748 0 7.03126 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2802 11.1936C11.1252 10.0208 9.59405 9.375 7.96876 9.375H6.09376C4.46851 9.375 2.93732 10.0208 1.78232 11.1936C0.63297 12.3606 0 13.901 0 15.5313C0 15.7901 0.209875 16 0.468751 16H13.5938C13.8526 16 14.0625 15.7901 14.0625 15.5313C14.0625 13.901 13.4296 12.3606 12.2802 11.1936Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.41a1a47052e42c0fa9cc52508dae0af6.svg";
export { ForwardRef as ReactComponent };